/*
 * @Author: cheesekun
 * @Date: 2021-04-07 14:41:10
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-07 16:27:45
 * @FilePath: \dc-vizier-tpl-h5\src\utils\request.js
 */
import axios from 'axios'

// axios config
axios.defaults.timeout = 50000
// axios.defaults.baseURL = '/activity/v1/'

// http requset interceptor
axios.interceptors.request.use(
  config => {
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response interceptor
axios.interceptors.response.use(
  res => {
    const { code } = res.data
    if (code !== 1) {
      return Promise.reject(res.data)
    }
    return Promise.resolve(res.data)
  },
  err => {
    return Promise.reject(err)
  }
)

export default axios
